import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headerStatusSubject = new BehaviorSubject<string>('IDN');
  headerStatus$ = this.headerStatusSubject.asObservable();

  updateHeaderStatus(status: string) {
    this.headerStatusSubject.next(status);
  }
}
